// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"_a67075eb","spinner":"_8a1b93f5","carouselList":"_9b8bca5a","arrowRight":"_d1803811","arrowLeft":"_80489dca","swiper":"_1f3aba02"};